import { render, staticRenderFns } from "./AttestationFormWrapper.vue?vue&type=template&id=7075f0de"
import script from "./AttestationFormWrapper.vue?vue&type=script&lang=js"
export * from "./AttestationFormWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports